// ReservationCodeModal.tsx
import React, { useState } from 'react';
import styles from './ReservationCodeModal.module.css';

const ReservationCodeModal= ({
  isOpen,
  onConfirm,
  onCancel,
  errorMessage = '',
}) => {
  const [codeInput, setCodeInput] = useState('');

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2 className={styles.title}>Enter Reservation Code</h2>
        <input
          type="text"
          value={codeInput}
          onChange={(e) => setCodeInput(e.target.value)}
          placeholder="6-digit code"
          className={styles.input}
        />
        {errorMessage && (
      <div className={styles.error}>
        {errorMessage}
      </div>
    )}
        <div className={styles.buttonRow}>
          <button
            onClick={() => {
              setCodeInput('');
              onCancel();
            }}
            className={styles.button}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm(codeInput);
              setCodeInput('');
            }}
            className={`${styles.button} ${styles.confirm}`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReservationCodeModal;